import * as actionTypes from "../actionTypes/actionTypes";
import {
  getToolsService,
  createNewToolService,
  updateToolService,
  deleteToolService
  } from "../services/ToolsService";
  import * as _ from "lodash";
const getTools = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_TOOLS
        })
        window.startLoading();
        getToolsService()
        .then((response)=>{
          const data = response.data;
          const sortedTools = _.sortBy(data, ['toolName']);
            dispatch({
                type: actionTypes.GET_TOOLS_SUCCESS,
                payload: sortedTools
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_TOOLS_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}


const createNewTool = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_TOOL,
    });
    window.startLoading();
    await createNewToolService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_TOOL_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_TOOL_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      })
  };
};

const updateTool = (toolId,requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_TOOL,
    });
    window.startLoading();
    await updateToolService(toolId, requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_TOOL_SUCCESS,
          payload: data,
          tooId: toolId
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_TOOL_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const deleteTool = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_TOOL
      })
      window.startLoading();
      await deleteToolService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_TOOL_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_TOOL_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      });
  }
}

export { getTools, createNewTool, updateTool, deleteTool };
